import FJTemplateWorkItem from './FJTemplateWorkItem';
import PropTypes from 'prop-types';

const FJTemplateWorkItemContainer = props => {
    const { item } = props;

    const onClick = () => {
        console.log('FJTemplateWorkItemContainer onClick', item);
    };

    return <FJTemplateWorkItem item={item} onClick={onClick} />;
};
FJTemplateWorkItemContainer.propTypes = {
    item: PropTypes.object.isRequired,
};
export default FJTemplateWorkItemContainer;
